export default {"src":"/_next/static/media/SWK.2c012c4a.svg","height":18,"width":18};